import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppLayoutMainContentComponent } from './app-layout-main-content.component';
import { AppLayoutComponent } from './app-layout.component';

@NgModule({
  imports: [CommonModule],
  exports: [AppLayoutComponent, AppLayoutMainContentComponent],
  declarations: [AppLayoutComponent, AppLayoutMainContentComponent],
  providers: []
})
export class AppLayoutModule {}
